import { NotificationTemplateType, ProjectSetting } from '@src/core';
import { AmandaColenExporter } from './exporters/amanda-colen.exporter';
import { Collect1Form } from './forms/collect1.form';
import { Collect2Form } from './forms/collect2.form';
import { Collect3Form } from './forms/collect3.form';
import { Collect4Form } from './forms/collect4.form';
import { ContactForm } from './forms/contact.form';
import { ExclusionForm } from './forms/exclusion.form';
import { FirstNotification } from './notifications/first.notification';
import { GratefulNotification } from './notifications/grateful.notification';
import { LinkNotification } from './notifications/link.notification';
import { Reminder1Notification } from './notifications/reminder-1.notification';
import { Reminder2Notification } from './notifications/reminder-2.notification';
import { Reminder3Notification } from './notifications/reminder-3.notification';

const ProjectPearlsFase2: ProjectSetting = {
  id: 'project-pearls-fase2',

  /**
   * Notifications
   */
  notifications: [
    // templateType: first
    {
      templateType: NotificationTemplateType.first,
      templateVariation: 1,
      content: FirstNotification,
    },

    // templateType: reminder
    {
      templateType: NotificationTemplateType.reminder,
      templateVariation: 1,
      content: Reminder1Notification,
    },

    {
      templateType: NotificationTemplateType.reminder,
      templateVariation: 2,
      content: Reminder2Notification,
    },

    {
      templateType: NotificationTemplateType.reminder,
      templateVariation: 3,
      content: Reminder3Notification,
    },

    // templateType: grateful
    {
      templateType: NotificationTemplateType.grateful,
      templateVariation: 1,
      content: GratefulNotification,
    },

    // templateType: linkOnly
    {
      templateType: NotificationTemplateType.linkOnly,
      templateVariation: 1,
      content: LinkNotification,
    },
  ],

  /**
   * Forms
   */
  forms: [
    {
      id: 'contact',
      template: ContactForm,
    },
    {
      id: 1,
      template: Collect1Form,
    },
    {
      id: 2,
      template: Collect2Form,
    },
    {
      id: 3,
      template: Collect3Form,
    },
    {
      id: 4,
      template: Collect4Form,
    },
    {
      id: 'exclusion',
      template: ExclusionForm,
    },
  ],

  /**
   * Exporters
   */
  exporters: [
    {
      alias: 'amanda-colen',
      template: AmandaColenExporter,
    },
  ],
};

export { ProjectPearlsFase2 };
